import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import VideoSection from "@/pages/home/components/VideoSection";
import PlatformIntro from "@/pages/home/components/PlatformIntro";
import { getHotVideos, getLatestVideos } from "@/utils/videoUtils";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Link } from "react-router-dom";

export default function Home() {
  usePageMeta({
    title: "西瓜视频免费 - 高清在线视频观看平台",
    description:
      "西瓜视频免费为您提供丰富多样的影视视频内容，包括电影、电视剧和综艺节目，满足您的在线视频观看需求。畅享高清画质，轻松搜索喜欢的视频资源。",
    keywords: "西瓜视频免费,免费视频,在线视频,高清电影,电视剧观看,影视平台,视频播放",
  });

  const hotVideos = getHotVideos(8);
  const latestVideos = getLatestVideos(8);

  return (
    <div className="pb-14 md:pb-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6 pt-6 md:pt-8">
        <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:flex-row md:items-center md:justify-between md:p-6">
          <div>
            <h1 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
              西瓜视频免费 · 高清在线视频观看平台
            </h1>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              电影、电视剧、综艺一站汇聚，分类清晰、搜索快捷，无需付费即可尽享高清影视内容。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line" />
              开始观看
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              了解平台
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-6 md:mt-8">
        <HeroCarousel />
      </div>

      <CategoryEntries />

      <VideoSection
        title="热门影片推荐"
        subtitle="大家都在看的高热度影视内容"
        icon="ri-fire-line"
        videos={hotVideos}
      />

      <VideoSection
        title="新片速递"
        subtitle="最新上线的影视与综艺，抢先观看"
        icon="ri-flashlight-line"
        videos={latestVideos}
      />

      <PlatformIntro />
    </div>
  );
}